import { FC } from 'react';

import Button, { ButtonProps } from 'components/_core/Button';
import { INTERCOM_LAUNCHER_PROPS } from 'features/Intercom';

type OpenHelpButtonProps = Omit<ButtonProps, 'onClick'>;

const OpenHelpButton: FC<OpenHelpButtonProps> = (props) => {
  return <Button {...INTERCOM_LAUNCHER_PROPS} {...props} />;
};

export default OpenHelpButton;
